// extracted by mini-css-extract-plugin
export var avatar = "_p6-3";
export var avatarContainer = "_p6-2";
export var avatarSpacer = "_p6-5";
export var avatarSpacerContainer = "_p6-4";
export var avatarStackContainer = "_p6-1";
export var bubble = "_p6-0";
export var remainderBubble = "_p6-6";